var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',{attrs:{"visible":!!_vm.state.name},on:{"close":_vm.close}},[_c(_vm.state.name,_vm._b({tag:"component",attrs:{"close":_vm.close}},'component',_vm.state.attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }